import React from 'react'
import './ModalPromo.css'
import { useState, useEffect } from 'react'
import fetchData from '../../../function/fetchData'
import { IoClose } from 'react-icons/io5';

const ModalPromo = ({state, setShowModalMenu}) => {
    // const [promoCount, setPromoCount] = useState(1)
    const [promoTel , setPromoTel] = useState("") 
    const [promoPrice, setPromoPrice] = useState(50)


    // Uloží změnu
    const handleChangeTel = (tel) => {
        fetchData(state.server + "api2/setPromo.php" , {token: state.tokenOfDriver, payload: "SET" , tel: promoTel,  promoPrice: promoPrice})
        .then( (res)=> {
            if(res.status === "OK"){
                if(res.info === "OK") {
                    alert("Promo přídáno pro tel: " + promoTel )
                    setShowModalMenu(false)
                } else {
                    alert(res.info)
                }
            } else {
                alert("server neodpovídá")
            }
        })

    }


  return (
    <div className='ModalMenuContainer'>
                    <IoClose size={30} color={"grey"} className="closeIcon" onClick={()=>setShowModalMenu(false)}/>
                     <div className="titleOfModal">
                            <h3>Promo</h3>
                    </div>
                    <div className="partnersContent">
    
                        <label htmlFor="">Tel:</label>
                        <input type="text" value={promoTel} onChange={(e)=> setPromoTel(e.target.value)}/>
                        <label htmlFor="">Sleva na jízdu v Kč:</label>
                        <input type="text" value={promoPrice} onChange={(e)=> setPromoPrice(e.target.value)}/>
                        <button onClick={() => handleChangeTel()}>Uložit</button>
                    </div>
                </div>
  )
}

export default ModalPromo
